import Vue from "vue";
// import store from "~/store";
import axios from "axios";
import VueAxios from "vue-axios";
import {Notification} from "element-ui";
// import VueAuth from '@websanova/vue-auth'
// import Events from "~/plugins/events";

Vue.use(VueAxios, axios.create());

// Vue.axios.defaults.baseURL = '/api/';

Vue.axios.defaults.params = {
    HTTP_MODAUTH: window.Travel.auth,
    ctx: "web",
};

Vue.axios.interceptors.request.use((request) => {

    // _log_("axios..interceptors..", request);
    request.headers.common["X-Requested-With"] = "XMLHttpRequest";


    return request;
});

Vue.axios.interceptors.response.use(
    (response) => {
        // request.headers.common["X-Requested-With"] = "XMLHttpRequest";

        if (!response.data) {
            alert("There was a problem with the internet connection. Please try again");
            window.location.href = '/'
            return Promise.reject(response);
        }
        if (
            response.data.message &&
            response.data.message == "Permission denied!"
        ) {
            alert("YOU ARE LOGGED OUT");
            window.location.href = '/'
            return Promise.reject(response.data);
        }
        if (response.data.success === false) {
            // _log_()
            Notification({
                title: 'Problem processing data!!',
                type: "error",
                duration: 6000,
                position: 'top-left',
                message: response.data.message.message || response.data.message || 'Something is going on with the server. Please try again in a few minutes. If the problem persists please call  S O F A R',
            });
            return Promise.reject(response.data);
        }
        return response;
    },
    (error) => {

        // const {
        //     data: {
        //         message,
        //             data: respdata,
        //             status: {statustext},
        //     },
        //     status,
        // } = error.response;
        // console.dir(JSON.stringify(error));

        const resp = error.response || error;
        let err_message = resp.statusText || resp.message;
        let title_err = 'Problem';
        if (err_message == 'Internal Server Error') {
            title_err = 'SafeControl has a problem'
            err_message = 'Something is going on with the server. Please try again in a few minutes. If the problem persists please call  S O F A R';
        }
        if (err_message.toLowerCase()
            .includes('network')) {
            title_err = 'Network problem'
            err_message = 'You may have a problem with your internet connection. If you keep working you will lose your data'
        }
        _log_("axios..error..", resp.status, err_message, resp);

        Notification({
            title: title_err,
            position: 'top-left',
            type: "error",
            duration: 6000,
            message: err_message,
        });
        // alert('!!Error:' + JSON.stringify(resp))

        return Promise.reject(error);
    }
);

// Vue.use(VueAuth, {
//     auth: {
//         request: function (req, token) {
//             this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
//         },
//         response: function (res) {
//             // Get Token from response body
//             return (res.data || {}).access_token;
//         }
//     },
//     http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//     router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//     refreshData: { enabled: false },
//     tokenStore: ['cookie']
// })

// Vue.$http = Vue.axios

export default {};
